(function(){
  var TARGET = 0.72;
  var MASS = 0.5;

  function analyse(img){
    try{
      var w = 140;
      var s = Math.min(w / img.naturalWidth, w / img.naturalHeight, 1);
      var iw = Math.max(1, Math.round(img.naturalWidth * s));
      var ih = Math.max(1, Math.round(img.naturalHeight * s));
      var c = document.createElement('canvas');
      c.width = iw; c.height = ih;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, iw, ih);
      var d = ctx.getImageData(0, 0, iw, ih).data;
      var x0 = iw, y0 = ih, x1 = -1, y1 = -1, sx = 0, sy = 0, n = 0;
      for (var y = 0; y < ih; y++){
        for (var x = 0; x < iw; x++){
          var i = (y * iw + x) * 4;
          var a = d[i+3], r = d[i], g = d[i+1], b = d[i+2];
          var bg = a < 16 || (r > 242 && g > 242 && b > 242);
          if (!bg){
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
            sx += x; sy += y; n++;
          }
        }
      }
      if (x1 < 0 || !n) return null;
      return { x0: x0/iw, y0: y0/ih, x1: (x1+1)/iw, y1: (y1+1)/ih, mx: (sx/n)/iw, my: (sy/n)/ih };
    } catch(e){ return null; }
  }

  function apply(img){
    if (!img.naturalWidth) return;
    var b = img._shcgBox || analyse(img);
    if (!b) return;
    img._shcgBox = b;
    var cw = img.clientWidth, ch = img.clientHeight;
    if (!cw || !ch) return;
    var r = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
    var rw = img.naturalWidth * r, rh = img.naturalHeight * r;
    var bw = (b.x1 - b.x0) * rw, bh = (b.y1 - b.y0) * rh;
    if (bw <= 0 || bh <= 0) return;
    var k = (TARGET * Math.min(cw, ch)) / Math.max(bw, bh);
    k = Math.max(0.3, Math.min(k, 3));
    var fx = (1 - MASS) * ((b.x0 + b.x1) / 2) + MASS * b.mx;
    var fy = (1 - MASS) * ((b.y0 + b.y1) / 2) + MASS * b.my;
    var cx = (fx - 0.5) * rw;
    var cy = (fy - 0.5) * rh;
    img.style.transformOrigin = 'center center';
    img.style.transform = 'scale(' + k.toFixed(3) + ') translate(' + (-cx / k).toFixed(1) + 'px,' + (-cy / k).toFixed(1) + 'px)';
  }

  function normalize(){
    var imgs = document.querySelectorAll('.shcg__img img');
    for (var i = 0; i < imgs.length; i++){
      (function(img){
        if (img.complete && img.naturalWidth) apply(img);
        else img.addEventListener('load', function(){ apply(img); });
      })(imgs[i]);
    }
  }

  function bind(acc){
    if (acc._shcgBound) return;
    acc._shcgBound = true;
    var btn = acc.querySelector('.shcg__sum');
    if (!btn) return;
    btn.addEventListener('click', function(){
      var open = acc.getAttribute('data-open') === 'true';
      acc.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) setTimeout(normalize, 360);
    });
  }

  function run(){
    normalize();
    var accs = document.querySelectorAll('.shcg__acc');
    for (var i = 0; i < accs.length; i++) bind(accs[i]);
  }

  var t;
  window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(normalize, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
